import React, { useMemo } from "react"
import { Container, Grid, Stack } from "@chakra-ui/react"
import ReactPlayer from "react-player/youtube"
import { SectionProps } from "@app/hoc/Section"
import { VideoContext, VideoDescription, VideoPlayButton, VideoTitle } from "@components/Video"
import useVideoNormaliser from "@hooks/useVideoNormaliser"
import VideoPosterRatio from "@components/Video/VideoPosterRatio"

export type VideoCalloutProps = GatsbyTypes.SanitySectionVideoCallout & SectionProps

const VideoCallout = ({ video: rawVideo, overrideShowDescription }: VideoCalloutProps) => {
  const { normaliseVideo } = useVideoNormaliser()
  const video = normaliseVideo(rawVideo)

  const showDescription = useMemo(() => {
    if (overrideShowDescription) {
      return !overrideShowDescription
    }
    return !video.showDescription
  }, [overrideShowDescription, video.showDescription])

  return (
    <Container py={3}>
      <VideoContext.Provider value={{ video }}>
        <Stack spacing={5}>
          {showDescription ? (
            <Stack alignItems="center" spacing={2}>
              <VideoTitle as="h2" size="h2" textAlign={["center", "left"]} fontWeight={300} />
              <VideoPosterRatio>
                <ReactPlayer
                  url={video.videoUrl || ""}
                  playing={false}
                  playIcon={<VideoPlayButton />}
                  light={video.poster?.src}
                  height={"100%"}
                  width={"100%"}
                />
              </VideoPosterRatio>
            </Stack>
          ) : (
            <Grid templateColumns={["none", "repeat(2, 1fr)"]} alignItems="center" gap={[2, 5]}>
              <VideoPosterRatio aspectRatioProps={{ ratio: 648 / 377 }}>
                <ReactPlayer
                  url={video.videoUrl || ""}
                  playing={false}
                  playIcon={<VideoPlayButton />}
                  light={video.poster?.src}
                  height={"100%"}
                  width={"100%"}
                />
              </VideoPosterRatio>
              <Stack spacing={3}>
                <VideoTitle display={["block", "none"]} as="h2" size="h2" />
                <VideoTitle display={["none", "block"]} as="h3" size="h3" />
                <VideoDescription />
              </Stack>
            </Grid>
          )}
        </Stack>
      </VideoContext.Provider>
    </Container>
  )
}

export default React.memo(VideoCallout)
